"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildingReducer = void 0;
var BuildingState_init_1 = require("@/pages/place/states/BuildingState.init");
var PlaceReducer_1 = require("@/pages/place/reducers/PlaceReducer");
exports.buildingReducer = function (state, action) {
    if (state === void 0) { state = BuildingState_init_1.defaultBuildingState; }
    return PlaceReducer_1.placeReducer(state, action);
};
